import * as Sentry from "@sentry/vue";

class ErrorUtils {

    static handleError = (e) => {
        const statusCode = e.response?.status;
        if (401 === statusCode) {
            return;
        }
        Sentry.captureException(e);
    }

    static toMessage(error) {
        if (error.code === 'ERR_NETWORK') {
            return "Erro de rede.";
        }

        const request = error.request;
        const response = error.response;
        let errorData = response?.data;

        if (this.isBlobError(request, errorData)) {
            return this.getBlobError(errorData);
        }

        if (401 === response?.status) {
            return errorData?.detail;
        }

        if (errorData?.errors) {
            return errorData.errors?.map(error => error).join('\n') || errorData.message || errorData;
        }

        return "Erro de rede.";
    }

    static async getBlobError(errorMessage) {
        const text = await errorMessage.text();
        errorMessage = errorMessage.type.toLowerCase().includes('json') ? JSON.parse(text) : text;
        return errorMessage.errors?.map(error => error).join('\r') || errorMessage.message || errorMessage;
    }

    static isBlobError(request, errorMessage) {
        return 'blob' === request?.responseType && errorMessage instanceof Blob && errorMessage?.type;
    }

}

export default ErrorUtils;